// extracted by mini-css-extract-plugin
export default {"title":"MyCourses_title__5nqEB"};